import { SignInButton as ClerkSignInButton, SignUpButton as ClerkSignUpButton, SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';

export function SignInButton() {
  return (
    <div className="flex items-center gap-2">
      <SignedOut>
        <div className="flex items-center bg-white dark:bg-slate-800 rounded-full shadow-sm overflow-hidden">
            <ClerkSignInButton mode="modal" appearance={{
                layout: {
                    socialButtonsVariant: "blockButton",
                    socialButtonsPlacement: "bottom"
                },
                elements: {
                    rootBox: "!w-full",
                    card: "!w-full !max-w-[550px] min-[430px]:!min-w-[430px]",
                    socialButtons: "flex flex-col gap-2 w-full",
                    socialButtonsBlockButton: "w-full flex justify-center items-center"
                }
            }}>
                <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-5 transition-colors max-[320px]:text-xs">
                    Iniciar Sesión
                </button>
            </ClerkSignInButton>
            <div className="w-px h-full bg-blue-700"></div>
            <ClerkSignUpButton mode="modal" appearance={{
                layout: {
                    socialButtonsVariant: "blockButton",
                    socialButtonsPlacement: "bottom"
                },
                elements: {
                    rootBox: "!w-full",
                    card: "!w-full !max-w-[550px] min-[430px]:!min-w-[430px]",
                    socialButtons: "flex flex-col gap-2 w-full",
                    socialButtonsBlockButton: "w-full flex justify-center items-center"
                }
            }}>
                <button className="bg-gray-700 hover:bg-gray-800 text-white font-medium py-2 px-5 transition-colors max-[320px]:text-xs">
                    Registrarse
                </button>
            </ClerkSignUpButton>
        </div>
      </SignedOut>
      <SignedIn>
        <UserButton 
          appearance={{
            elements: {
              avatarBox: "w-8 h-8"
            }
          }}
        />
      </SignedIn>
    </div>
  );
}